import React, { PureComponent } from 'react';
import { Translate } from 'react-redux-i18n';

import StringUtil from '../../app/utils/string';


class ClientImportErrors extends PureComponent {
  render() {
    const { errors = [] } = this.props;

    if (!errors.length) return null;

    return (
      <div className="clients-errors">
        <hr />

        <h5 style={{ color: "red" }}><strong><Translate value="dragAndDropClientErrorTitle" /></strong></h5>

        {errors.map(error => (
          <React.Fragment key={error.code}>
            <p>
              <Translate value="code" />
              {': '}
              <b>{error.code}</b>

              {' - '}
              <Translate value="line" />
              {' '}
              {error.line}
              {': '}

              {error && error.types.length && error.types.map((type, index) => (
                <React.Fragment>
                  <Translate value={`dragAndDropClientError${StringUtil.capitalizeFirstLetter(type)}`} />
                  {index !== error.types.length - 1 ? ', ' : ''}
                </React.Fragment>
              ))}
            </p>
          </React.Fragment>
        ))}
      </div>
    );
  }
}

export default ClientImportErrors;
